import { Tag, TagVariant } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export type RebatedTagType = 'fully' | 'partially' | 'default';

const textKey = {
    fully: TextKey.FullyRebated,
    partially: TextKey.PartiallyRebated,
    default: TextKey.Rebated,
};

const variant: Record<string, TagVariant> = {
    fully: 'tangerine',
    partially: 'mustard',
    default: 'basicBold',
};

const tagPropsMap = {
    fully: { 'data-test-fully-rebated': true },
    partially: { 'data-test-partially-rebated': true },
    default: { 'data-test-rebated': true },
};

interface RebatedTagProps {
    type?: RebatedTagType;
}

const RebatedTag = ({ type = 'default' }: RebatedTagProps) => (
    <Tag variant={variant[type]} {...tagPropsMap[type]}>
        <LocalizedText textKey={textKey[type]} />
    </Tag>
);

export default RebatedTag;
